'use strict';
import './styles.css';

const chessboard = document.querySelector('#chessboard');
const questionDiv = document.querySelector('#question');
const startButton = document.querySelector('#start-button');
const gameInfo = document.querySelector('#game-panel');
const totalScore = document.querySelector('#total-score');
const numQuestions = document.querySelector('#total-questions');
const playAgain = document.querySelector('#play-again');
const playAgainButton = document.querySelector('#play-again-button');
const timer = document.querySelector('#timer');
const pieceColor = document.querySelector('#pieceColor');
const perspective = document.querySelectorAll('.perspective');
const typeButton = document.querySelectorAll('.type-button');
const trainingType = document.querySelector('#training-type');
const answerTiles = document.querySelector('#answer-tiles');

let quizQuestion = null;
let score = 0;
let interval = null;
let black = false;
let totalQuestions = 0;
let coord = [];
let colorMode = false;

// prettier-ignore
let whiteCoord = [
          'a8', 'b8', 'c8', 'd8', 'e8', 'f8', 'g8', 'h8',
          'a7', 'b7', 'c7', 'd7', 'e7', 'f7', 'g7', 'h7',
          'a6', 'b6', 'c6', 'd6', 'e6', 'f6', 'g6', 'h6',
          'a5', 'b5', 'c5', 'd5', 'e5', 'f5', 'g5', 'h5',
          'a4', 'b4', 'c4', 'd4', 'e4', 'f4', 'g4', 'h4',
          'a3', 'b3', 'c3', 'd3', 'e3', 'f3', 'g3', 'h3',
          'a2', 'b2', 'c2', 'd2', 'e2', 'f2', 'g2', 'h2',
          'a1', 'b1', 'c1', 'd1', 'e1', 'f1', 'g1', 'h1'
        ];

// prettier-ignore
let blackCoord = [
          'h1', 'g1', 'f1', 'e1', 'd1', 'c1', 'b1', 'a1', 
          'h2', 'g2', 'f2', 'e2', 'd2', 'c2', 'b2', 'a2', 
          'h3', 'g3', 'f3', 'e3', 'd3', 'c3', 'b3', 'a3', 
          'h4', 'g4', 'f4', 'e4', 'd4', 'c4', 'b4', 'a4', 
          'h5', 'g5', 'f5', 'e5', 'd5', 'c5', 'b5', 'a5', 
          'h6', 'g6', 'f6', 'e6', 'd6', 'c6', 'b6', 'a6', 
          'h7', 'g7', 'f7', 'e7', 'd7', 'c7', 'b7', 'a7', 
          'h8', 'g8', 'f8', 'e8', 'd8', 'c8', 'b8', 'a8'
        ]

// prettier-ignore
const color = [
          'w', 'b', 'w', 'b', 'w', 'b', 'w', 'b',
          'b', 'w', 'b', 'w', 'b', 'w', 'b', 'w',
          'w', 'b', 'w', 'b', 'w', 'b', 'w', 'b',
          'b', 'w', 'b', 'w', 'b', 'w', 'b', 'w',
          'w', 'b', 'w', 'b', 'w', 'b', 'w', 'b',
          'b', 'w', 'b', 'w', 'b', 'w', 'b', 'w',
          'w', 'b', 'w', 'b', 'w', 'b', 'w', 'b',
          'b', 'w', 'b', 'w', 'b', 'w', 'b', 'w'
        ];

const drawBoard = (view = 'white') => {
  coord = whiteCoord;
  let output = '';

  if (view === 'none') {
    for (let i = 0; i < 64; i++) {
      output += `<div class="square lightSquare" data-coord="${coord[i]}"></div>`;
    }
    chessboard.classList.add('color-trainer');
    chessboard.innerHTML = output;
    return;
  }

  if (view === 'black') {
    coord = blackCoord;
  }

  for (let i = 0; i < 64; i++) {
    let squareColor = color[i] === 'w' ? 'lightSquare' : 'darkSquare';

    output += `<div class="square ${squareColor}" data-coord="${coord[i]}"></div>`;
  }

  chessboard.innerHTML = output;
};

const generateQuizQuestion = () => {
  const randomNum = Math.floor(Math.random() * 63);
  quizQuestion = coord[randomNum];
  questionDiv.innerText = quizQuestion;
};

const checkAnswer = (e) => {
  if (colorMode === true) {
    return;
  }

  if (interval > 0) {
    totalQuestions = totalQuestions + 1;
    numQuestions.innerText = totalQuestions;

    if (e.target.dataset.coord === quizQuestion) {
      score++;
      totalScore.innerText = score;
      generateQuizQuestion();
    } else {
      questionDiv.classList.add('warning');
      setTimeout(function () {
        questionDiv.classList.remove('warning');
        generateQuizQuestion();
      }, 250);
    }
  }
};

const countdown = (seconds) => {
  timer.innerText = seconds;

  generateQuizQuestion();

  interval = setInterval(() => {
    seconds = seconds - 0.1;
    seconds = seconds.toFixed(1);

    timer.innerText = seconds;

    if (seconds <= 0) {
      clearInterval(interval);
      interval = 0;
      timer.innerText = "Time's up!";
      question.classList.add('display-none');
      playAgain.classList.remove('display-none');
      return;
    }
  }, 100);
};

chessboard.addEventListener('click', checkAnswer);

answerTiles.addEventListener('click', (e) => {
  if (!e.target.dataset.color) {
    return;
  }

  if (interval > 0) {
    totalQuestions = totalQuestions + 1;
    numQuestions.innerText = totalQuestions;
    const questionIndex = whiteCoord.indexOf(quizQuestion);

    if (e.target.dataset.color === color[questionIndex]) {
      score++;
      totalScore.innerText = score;
      generateQuizQuestion();
    } else {
      questionDiv.classList.add('warning');
      setTimeout(function () {
        questionDiv.classList.remove('warning');
        generateQuizQuestion();
      }, 250);
    }
  }

  chessboard.addEventListener('click', checkAnswer);
});

trainingType.addEventListener('click', (e) => {
  const type = e.target.dataset.type;

  typeButton.forEach((item) => {
    item.classList.remove('selected-type');
  });

  e.target.classList.add('selected-type');

  if (type === 'squares') {
    colorMode = true;
    answerTiles.classList.remove('display-none');
    // CHANGE - HIDE BOARD
    chessboard.classList.add('display-none');
    pieceColor.classList.add('display-none');
    // drawBoard('none');
  } else {
    // CHANGE - SHOW BOARD
    chessboard.classList.remove('display-none');
    pieceColor.classList.remove('display-none');
    colorMode = false;
    perspective.forEach((item) => {
      const buttonClass = item.classList.value;
      answerTiles.classList.add('display-none');

      if (buttonClass.includes('selected')) {
        if (buttonClass.includes('whitePieces')) {
          drawBoard('white');
        } else {
          drawBoard('black');
        }
      }
    });
  }
});

startButton.addEventListener('click', () => {
  startButton.classList.add('display-none');
  gameInfo.classList.remove('display-none');
  countdown(30);
});

playAgainButton.addEventListener('click', () => {
  question.classList.remove('display-none');
  playAgain.classList.add('display-none');

  // playAgain.classList.add('display-none');
  // timer.classList.remove('display-none');
  quizQuestion = null;
  score = 0;
  interval = null;
  totalQuestions = 0;
  totalScore.innerText = score;
  numQuestions.innerText = totalQuestions;
  countdown(30);
});

pieceColor.addEventListener('click', (e) => {
  perspective.forEach((item) => {
    item.classList.remove('selected');
  });

  const classList = e.target.classList.value;

  if (classList.includes('blackPieces')) {
    black = true;
    drawBoard('black');
  } else {
    black = false;
    drawBoard('white');
  }

  // e.target.classList.remove('perspective');
  e.target.classList.add('selected');

  // const selectedDiv = e.target.classList.add('selected');
});

window.addEventListener('DOMContentLoaded', () => drawBoard('white'));
